import { render, staticRenderFns } from "./Printer2.vue?vue&type=template&id=a5d2e580"
import script from "./Printer2.vue?vue&type=script&lang=js"
export * from "./Printer2.vue?vue&type=script&lang=js"
import style0 from "./Printer2.vue?vue&type=style&index=0&id=a5d2e580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports